var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loop"},[_c('div',{staticClass:"container"},[_c('div',{ref:"loop",style:({ width: `${_vm.width}`, height: `${_vm.height}` })}),_c('img',{staticClass:"wc",attrs:{"src":require("../../assets/img/layout/wc.png"),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }